import Vue from 'vue'
import Vuex from 'vuex'
import userNoList from './modules/userNoList'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {userNoList},
  plugins: [
    createPersistedState({ storage: window.sessionStorage })
  ]
})



// WEBPACK FOOTER //
// ./src/store/index.js